import { getCurrentSubdomain } from "utils/helpers";
import vars from "utils/vars";

/**
 * Skyflow proxy `fetch` calls bypass axios interceptors, so we must add Tenant + Bearer headers
 * here. Shared by `index.js` (records / files) and `postPatientDocument.js` (DOB-gated download).
 */
export const withAuthAndTenantHeaders = (headers = {}) => {
	const localhostFallbackTenant =
		!vars.isProduction && vars.app.allowLocalHostToMultiTenantDomains
			? vars.app.localSubdomain || vars?.patients?.tenantName || vars?.justmeds?.tenantName
			: null;

	const tenant =
		headers.Tenant ||
		headers.tenant ||
		vars.api.headers?.Tenant ||
		vars.api.headers?.tenant ||
		getCurrentSubdomain() ||
		localhostFallbackTenant;

	const tokenKey = vars?.localStorage?.fieldsName?.token || "token";
	const token = typeof window !== "undefined" ? window?.localStorage?.getItem(tokenKey) : null;
	const authHeader =
		headers.Authorization ||
		headers.authorization ||
		vars.api.headers?.Authorization ||
		vars.api.headers?.authorization ||
		(token ? `Bearer ${token}` : null);

	return {
		...headers,
		...(tenant ? { Tenant: tenant } : {}),
		...(authHeader ? { Authorization: authHeader } : {}),
	};
};

export const parseFetchResponseBody = async (response) => {
	if (!response) return null;
	try {
		const contentType = response.headers?.get?.("content-type") || "";
		if (contentType.includes("application/json")) return await response.json();
		return await response.text();
	} catch (_e) {
		return null;
	}
};

const extractErrorMessage = (payload, response) => {
	const fallback = response?.statusText || "Request failed";
	if (!payload) return fallback;
	if (typeof payload === "string") return payload || fallback;
	// Laravel: { message }, Skyflow proxy: { error: { message } }
	if (payload?.error?.message) return payload.error.message;
	if (payload?.message) return payload.message;
	return fallback;
};

/** Axios-shaped error so `errorResponseInterceptor` can render it consistently. */
export const makeFetchError = (response, payload) => {
	const err = new Error(extractErrorMessage(payload, response));
	err.status = response?.status;
	err.payload = payload;
	err.response = { status: response?.status, statusText: response?.statusText, data: payload };
	return err;
};
